module.exports = __webpack_public_path__ + "static/img/tab1en-Jj7Kk8Ll.0285e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/tab1en-Jj7Kk8Ll.png
// module id = 1M0K
// module chunks = 16